import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;
  width: 100%;
`

export const BindingWrapper = styled.div`
  flex: 1 1 100px;
  min-width: 0;
`

export const DropdownWrapper = styled.div`
  flex: 0 0 68px;
`

export const InputWrapper = styled.div`
  flex: 0 1 100px;
  min-width: 0;
  position: relative;
`
